import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import cloneDeep from 'lodash.clonedeep';
import * as u8a from 'uint8arrays';
import { toCID } from './cid-utils.js';
import { AnchorStatus } from '../stream.js';
import { StreamID, StreamType } from '@ceramicnetwork/streamid';
export var StreamUtils = /*#__PURE__*/function () {
  function StreamUtils() {
    _classCallCheck(this, StreamUtils);
  }
  _createClass(StreamUtils, null, [{
    key: "streamIdFromState",
    value: function streamIdFromState(state) {
      return new StreamID(state.type, state.log[0].cid);
    }
  }, {
    key: "serializeCommit",
    value: function serializeCommit(commit) {
      var cloned = cloneDeep(commit);
      if (StreamUtils.isSignedCommitContainer(cloned)) {
        cloned.jws.link = cloned.jws.link.toString();
        cloned.linkedBlock = u8a.toString(cloned.linkedBlock, 'base64');
        if (cloned.cacaoBlock) {
          cloned.cacaoBlock = u8a.toString(cloned.cacaoBlock, 'base64');
        }
        return cloned;
      }
      if (StreamUtils.isSignedCommit(commit)) {
        cloned.link = cloned.link.toString();
      }
      if (StreamUtils.isAnchorCommit(commit)) {
        cloned.proof = cloned.proof.toString();
      }
      if (cloned.id) {
        cloned.id = cloned.id.toString();
      }
      if (cloned.prev) {
        cloned.prev = cloned.prev.toString();
      }
      return cloned;
    }
  }, {
    key: "deserializeCommit",
    value: function deserializeCommit(commit) {
      var cloned = cloneDeep(commit);
      if (StreamUtils.isSignedCommitContainer(cloned)) {
        cloned.jws.link = toCID(cloned.jws.link);
        cloned.linkedBlock = u8a.fromString(cloned.linkedBlock, 'base64');
        if (cloned.cacaoBlock) {
          cloned.cacaoBlock = u8a.fromString(cloned.cacaoBlock, 'base64');
        }
        return cloned;
      }
      if (StreamUtils.isSignedCommit(cloned)) {
        cloned.link = toCID(cloned.link);
      }
      if (StreamUtils.isAnchorCommit(cloned)) {
        cloned.proof = toCID(cloned.proof);
      }
      if (cloned.id) {
        cloned.id = toCID(cloned.id);
      }
      if (cloned.prev) {
        cloned.prev = toCID(cloned.prev);
      }
      return cloned;
    }
  }, {
    key: "serializeState",
    value: function serializeState(state) {
      var cloned = cloneDeep(state);
      cloned.log = cloned.log.map(function (entry) {
        return _objectSpread(_objectSpread({}, entry), {}, {
          cid: entry.cid.toString()
        });
      });
      if (cloned.anchorStatus != null) {
        cloned.anchorStatus = AnchorStatus[cloned.anchorStatus];
      }
      if (cloned.anchorScheduledFor != null) {
        cloned.anchorScheduledFor = new Date(cloned.anchorScheduledFor).toISOString();
      }
      if (cloned.anchorProof != null) {
        cloned.anchorProof.txHash = cloned.anchorProof.txHash.toString();
        cloned.anchorProof.root = cloned.anchorProof.root.toString();
      }
      if (cloned.lastAnchored != null) {
        cloned.lastAnchored = cloned.lastAnchored.toString();
      }
      cloned.doctype = StreamType.nameByCode(cloned.type);
      return cloned;
    }
  }, {
    key: "deserializeState",
    value: function deserializeState(state) {
      var cloned = cloneDeep(state);
      if (cloned.doctype) {
        cloned.type = StreamType.codeByName(cloned.doctype);
        delete cloned.doctype;
      }
      cloned.log = cloned.log.map(function (entry) {
        return _objectSpread(_objectSpread({}, entry), {}, {
          cid: toCID(entry.cid)
        });
      });
      if (cloned.anchorProof) {
        cloned.anchorProof.txHash = toCID(cloned.anchorProof.txHash);
        cloned.anchorProof.root = toCID(cloned.anchorProof.root);
      }
      var showScheduledFor = true;
      if (cloned.anchorStatus) {
        cloned.anchorStatus = AnchorStatus[cloned.anchorStatus];
        showScheduledFor = cloned.anchorStatus !== AnchorStatus.FAILED && cloned.anchorStatus !== AnchorStatus.ANCHORED;
      }
      if (cloned.anchorScheduledFor) {
        if (showScheduledFor) {
          cloned.anchorScheduledFor = Date.parse(cloned.anchorScheduledFor);
        } else {
          delete cloned.anchorScheduledFor;
        }
      }
      if (cloned.lastAnchored) {
        cloned.lastAnchored = toCID(cloned.lastAnchored);
      }
      return cloned;
    }
  }, {
    key: "statesEqual",
    value: function statesEqual(state1, state2) {
      return JSON.stringify(StreamUtils.serializeState(state1)) === JSON.stringify(StreamUtils.serializeState(state2));
    }
  }, {
    key: "isStateSupersetOf",
    value: function isStateSupersetOf(state, base) {
      if (state.log.length < base.log.length) {
        return false;
      }
      for (var i in base.log) {
        if (!state.log[i].cid.equals(base.log[i].cid)) {
          return false;
        }
      }
      if (state.anchorStatus != base.anchorStatus) {
        return false;
      }
      return true;
    }
  }, {
    key: "convertCommitToSignedCommitContainer",
    value: function () {
      var _convertCommitToSignedCommitContainer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(commit, ipfs) {
        var block;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!StreamUtils.isSignedCommit(commit)) {
                _context.next = 5;
                break;
              }
              _context.next = 3;
              return ipfs.block.get(commit.link);
            case 3:
              block = _context.sent;
              return _context.abrupt("return", {
                jws: commit,
                linkedBlock: block
              });
            case 5:
              return _context.abrupt("return", commit);
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function convertCommitToSignedCommitContainer(_x, _x2) {
        return _convertCommitToSignedCommitContainer.apply(this, arguments);
      }
      return convertCommitToSignedCommitContainer;
    }()
  }, {
    key: "isSignedCommitContainer",
    value: function isSignedCommitContainer(commit) {
      return commit && commit.jws !== undefined;
    }
  }, {
    key: "isSignedCommit",
    value: function isSignedCommit(commit) {
      return commit && commit.link !== undefined;
    }
  }, {
    key: "isAnchorCommit",
    value: function isAnchorCommit(commit) {
      return commit && commit.proof !== undefined;
    }
  }, {
    key: "isSignedCommitData",
    value: function isSignedCommitData(commitData) {
      return commitData && commitData.envelope !== undefined;
    }
  }, {
    key: "isAnchorCommitData",
    value: function isAnchorCommitData(commitData) {
      return commitData && commitData.proof !== undefined;
    }
  }]);
  return StreamUtils;
}();